import { WorkModel } from '@Entities/work/work'
import { WorkFlag } from '@App/enum/work-flag'

export const isWorkPublicDomain = (workItem: WorkModel) => workItem.flags?.includes(WorkFlag.PUBLIC_DOMAIN)

export const isNonMusicalWork = (workItem: WorkModel) => workItem.flags?.includes(WorkFlag.NON_MUSICAL)
